const axios = require('axios')

const BaseUrl = ip.baseUrl + 'api/'
const ApiAction = 'tv'
const ApiKey = 14542454168651115344876

function packageCollapse() {
  $('.ipWidget-TvPackages .card-header').click(function(e) {
    e.preventDefault()
    var iden = $(this).data('iden')
    var mode = $(this).data('mode')
    var subcat = $(this).data('subcat')
    if ($(this).hasClass('collapsed')) {
      getApiData(iden, mode, subcat)
      $('.ipWidget-TvPackages .card:not(.collapsed)').addClass('collapsed')
      $(this)
        .parent()
        .removeClass('collapsed')
    } else {
      $(this)
        .parent()
        .addClass('collapsed')
      $('#output-' + iden).empty()
    }
  })
}

function genApiUrl() {
  return BaseUrl + ApiAction
}

function getApiData(iden, mode, subcat) {
  var apiUrl = genApiUrl()
  axios
    .get(apiUrl, {
      params: {
        iden: iden,
        mode: mode,
        subcat: subcat,
        limit: 0,
        apikey: ApiKey
      },
      method: 'get'
    })
    .then(function(response) {
      var output = response.data.content.output
      $('#output-' + iden).html(output)
    })
    .catch(function() {})
}

export { packageCollapse }
